import { injectGlobal } from 'styled-components';

// tslint:disable-next-line:no-unused-expression
injectGlobal`
  body {
    background: #F6F6F6;
    font-family: Avenir, sans-serif;
  }

  html {
    font-size: 16px;
  }
`;


// WEBPACK FOOTER //
// src/app/src/styles/global.s.ts